import { SearchQuery } from "@planzone/dto";

function matchTypes(first: SearchQuery["types"], second: SearchQuery["types"]) {
  return (
    (first === undefined && second === undefined) ||
    (Array.isArray(first) && Array.isArray(second)
      ? first.every((type) => second.find((t) => t === type)) &&
        second.every((type) => first.find((t) => t === type))
      : false)
  );
}

function matchQuery(first: SearchQuery, second: SearchQuery) {
  return first.name === second.name && matchTypes(first.types, second.types);
}

export { matchQuery };
